import React, { useState, useEffect } from "react";
import { ShimmerPostItem } from "react-shimmer-effects";
import Header from "../Header/Header";
import { MdStar } from "react-icons/md";
import locationIcon from "../../assets/img/Location.svg";
import ArroIcon from "../../assets/img/Arrow - Left 2.svg"
import calendarIcon from "../../assets/img/Calendar.svg";
import Calendars from "../Prodouctpage/Calenders";
import axios from "axios";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import whatsapp from "../../assets/img/whatsapp-removebg-preview.png";
import { IoIosArrowForward } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";
import { Helmet } from "react-helmet";
import { IoCallOutline } from "react-icons/io5";
import { MdCopyAll } from "react-icons/md";
import { IoShareSocialOutline } from "react-icons/io5";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
import { MdDeleteForever } from "react-icons/md";
import slugify from "slugify";
import { MdEdit } from "react-icons/md";
import { HiMiniShare } from "react-icons/hi2";
const ProdouctCloth = () => {
  const [product, setProduct] = useState(null);
  const [userRating, setUserRating] = useState(0);
  const { productId: productIdFromParams } = useParams();
  const location = useLocation();
  const productId =
    location.state?.productId ||
    productIdFromParams ||
    new URLSearchParams(location.search).get("productId");
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const token = localStorage.getItem("token");
  const { t } = useTranslation();
  const loggedInUser = JSON.parse(localStorage.getItem("user") || "{}");
  const isMyProduct = product?.userId?._id === loggedInUser?._id;
  const [selectedImage, setSelectedImage] = useState("");
  const images = product?.images || [];
  const [reviewText, setReviewText] = useState("");
  const [reviews, setReviews] = useState([]);
  const [copied, setCopied] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false); // NEW STATE FOR POPUP
  const handleRedirect = (phoneNumber, productTitle) => {
    if (!product || !phoneNumber) return;

    // 1️⃣ Remove everything except digits
    let clean = phoneNumber.replace(/\D/g, "");

    // 2️⃣ Force India country code
    if (clean.length === 10) {
      clean = "91" + clean;
    }

    // 3️⃣ If starts with 91 but longer than 12, keep last 10 digits
    if (clean.startsWith("91") && clean.length > 12) {
      clean = "91" + clean.slice(-10);
    }
    const VenderName = `${product?.userId?.name || ""} ${product?.userId?.lastName || ""}`.trim() || "Seller";


    const productLink = `https://rentel.in/${slugify(product.category || "")}/${slugify(
      product.subCategory || ""
    )}/${slugify(product.title || "")}/${product._id}`;

    const rawMessage = `Hi! ${VenderName} 👋

💫 Your ${productTitle} looks absolutely amazing on Rentel! 😍
I just came across your listing — it’s exactly what I was looking for! 🛍️

Could you please guide me on the next steps for booking and delivery? 🚚💬

👉 ${productLink}`;

    // ✅ Must encode entire message here
    const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(rawMessage)}`;
    // 4️⃣ Official WhatsApp mobile-safe URL
    const url = `https://wa.me/${clean}?text=${encodeURIComponent(rawMessage)}`;

    window.open(url, "_blank");
    window.open(whatsappURL, "_blank");
  };


  const handlePhoneCall = (phoneNumber) => {
    if (!phoneNumber) {
      alert("Phone number not available");
      return;
    }
    window.open(`tel:${phoneNumber}`);
  };

  const handleAddReview = async () => {
    if (userRating === 0 || reviewText.trim() === "") {
      alert("Please provide a rating and write a review.");
      return;
    }

    const newReview = {
      productId: product._id,
      rating: userRating,
      reviewText,
    };

    try {
      const res = await axios.post(
        "https://network.rentel.in/reviews/add",
        newReview,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data?.review) {
        setReviews((prev) => [...prev, res.data.review]);
      }

      setUserRating(0);
      setReviewText("");
    } catch (err) {
      console.error("Error posting review:", err.response?.data || err.message);
      alert(err.response?.data?.message || "Something went wrong. Try again.");
    }
  };

  const fetchSingleProduct = async () => {
    try {
      const res = await axios.get(
        `https://network.rentel.in/products/get-user-products?productId=${productId}`
      );
      const firstProduct = res.data.product;
      setProduct(firstProduct);
      setSelectedImage(firstProduct.images?.[0] || "");
      setReviews(firstProduct.reviews || []);
    } catch (err) {
      console.error("Failed to load product", err);
    }
  };


  useEffect(() => {
    fetchSingleProduct();
  }, []);


  const handleSharea = (product) => {
    const shareData = {
      title: product.title,
      text: `Check out this product on Rentel! ${product.title}`,
      url: `https://rentel.in/${product.category}/${product.subCategory}/${product.title}/${product._id}`,
    };

    if (navigator.share) {
      navigator.share(shareData)
    } else {
      // Fallback (copy to clipboard)
      navigator.clipboard.writeText(shareData.url);
      alert("Link copied to clipboard!");
    }
  };

  const handleMenuToggle = (id) => {
    setActiveMenu((prev) => (prev === id ? null : id));
  };

  const handleEdit = async (id) => {
    const reviewToEdit = reviews.find((r) => r._id === id);
    if (!reviewToEdit) return;
    const updatedAtText = prompt("Edit your review:", reviewToEdit.text);
    const updatedAtRating = parseInt(
      prompt("Edit rating (1-5):", reviewToEdit.rating)
    );
    if (!updatedAtText || isNaN(updatedAtRating)) return;
    try {
      const response = await axios.put(
        "https://network.rentel.in/reviews/edit",
        {
          reviewId: id,
          reviewText: updatedAtText,
          rating: updatedAtRating,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const updatedAtReviews = reviews.map((r) =>
          r._id === id
            ? { ...r, text: updatedAtText, rating: updatedAtRating }
            : r
        );
        setReviews(updatedAtReviews);
        alert("Review updated!");
      }
    } catch (error) {
      console.error("Edit failed", error);
      alert("Failed to update review");
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this review?"
    );
    if (!confirmDelete) return;
    try {
      const response = await axios.delete(
        "https://network.rentel.in/reviews/delete",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: {
            reviewId: id,
          },
        }
      );
      if (response.status === 200) {
        const updatedAtReviews = reviews.filter((r) => r._id !== id);
        setReviews(updatedAtReviews);
        alert("Review deleted!");
      }
    } catch (error) {
      console.error("Delete failed", error);
      alert("Failed to delete review");
    }
  };

  const fullAddress = `${product?.location?.address} ${product?.location?.area} ${product?.location?.city} ${product?.location?.state} ${product?.location?.country}, ${product?.location?.zipCode}`;
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
      setShowPopup(false);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Product Location",
          text: fullAddress,
        });
      } else {
        alert("Share not supported on this device.");
      }
      setShowPopup(false);
    } catch (err) {
      console.error("Share failed", err);
    }
  };

  const calculateDiscountedPrice = (price, discount = 0) => {
    const p = Number(price);
    const d = Number(discount);
    return d > 0 ? Math.trunc(p - (p * d) / 100) : Math.trunc(p);
  };

  const copyAddress = () => {
    if (fullAddress) {
      navigator.clipboard.writeText(fullAddress).then(() => {
        setCopied(true);

        setTimeout(() => {
          setCopied(false);
        }, 1500); // 1.5 second pachi hide
      });
    }
  };



  const category = (product?.category || "").toLowerCase();

  let productInfo = [];

  if (category === "cloth") {
    productInfo = [
      { label: "Size", value: product?.size },
      { label: "Fit type", value: product?.fitType },
      { label: "Color", value: product?.clothColor },
      { label: "Material", value: product?.material },
      { label: "Sleeve length", value: product?.sleeveLength },
      { label: "Neck style", value: product?.neckStyle },
      { label: "Pattern / Print", value: product?.patternPrint },
    ];
  }

  if (category === "car") {
    productInfo = [
      { label: "Car model", value: product?.carModel },
      { label: "Color", value: product?.color },
      { label: "Year", value: product?.carYear },
      { label: "Body type", value: product?.bodyType },
      { label: "Transmission", value: product?.transmission },
      { label: "Fuel type", value: product?.fuelType },
      { label: "Mileage", value: product?.mileage },
      { label: "Drive train", value: product?.driveTrain },
    ];
  }

  if (category === "property") {
    productInfo = [
      { label: "Property type", value: product?.propertyType },
      { label: "Area (sq ft)", value: product?.squareFootArea },
      { label: "Bedrooms", value: product?.noOfBedroom },
      { label: "Bathrooms", value: product?.noOfBathroom },
      { label: "Furnishing", value: product?.furnishingStatus },
      { label: "Ownership", value: product?.ownershipType },
      { label: "propertyCondition", value: product?.propertyCondition },


    ];
  }

  // zoom and back handling
  const [zoomedIndex, setZoomedIndex] = useState(null);
  const [origin, setOrigin] = useState({ x: "50%", y: "50%" });

  const handleMove = (e, index) => {
    if (zoomedIndex !== index) return;

    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setOrigin({ x: `${x}%`, y: `${y}%` });
  };


  const handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      navigate("/");
    }
    if (productId) {
      fetchSingleProduct();
    }
  };

  const handleAction = (action, ...args) => {
    if (!token) {
      setShowLoginPopup(true);
      return;
    }

    if (action === "call") {
      handlePhoneCall(...args);
    } else if (action === "chat") {
      handleRedirect(...args);
    } else if (action === "addReview") {
      handleAddReview();
    }
  };

  if (!product) {
    return (
      <div className="shimmer-wrapper">
        <ShimmerPostItem card title text cta />
      </div>
    );
  }

  const driverTypeLabel = (value) => {
    const map = {
      with_vehicle: "With vehicle",
      without_vehicle: "Without vehicle",
      both: "Both",
    };

    return map[value] || value;
  };
  const hasValidValue = (value) => {
    return value !== undefined && value !== null && value.trim() !== "";
  };

  const toProperCase = (text = "") =>
    text
      .toString()
      .trim()
      .split(/\s+/)
      .map(word =>
        word
          ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          : ""
      )
      .join(" ");




  return (
    <>
      <Helmet>
        <title>{product?.title} | Rentel</title>

        <meta
          name="description"
          content={product?.description || "Rent this product easily on Rentel"}
        />

        <meta property="og:title" content={product?.title} />
        <meta property="og:description" content={product?.description} />
        <meta property="og:image" content={product?.images?.[0]} />
      </Helmet>

      <NoZoomWrapper>
        <NoCopyWrapper>
          {/* <Menu /> */}
          <div className="container">
            <div className="desktop-only">
              <Header />
              <div className="breadcrumb" onClick={() => handleBack()}>
                Home{" "}
                <span className="arro">
                  <IoIosArrowForward />
                </span>{" "}
                <div className="product">{product.category}</div>
              </div>
              <div className="product-header">
                <div className="product-detail-container">

                  <div className="product-main">
                    <div className="main-image-container">
                      <img
                        src={selectedImage}
                        alt="Selected"
                        className="main-image"
                      />
                    </div>
                  </div>
                  <div className="thumbnail-column">
                    {product.images
                      .filter((img) => img && img.trim() !== "")
                      .map((img, idx) => (
                        <img
                          key={idx}
                          src={img}
                          alt={`thumb-${idx}`}
                          className={`thumbnail ${selectedImage === img ? "active" : ""
                            }`}
                          onClick={() => setSelectedImage(img)}
                        />
                      ))}
                  </div>
                  <div className="share-container">
                    <div className="dots-paginations">
                      {product.images.map((img, idx) => (
                        <span
                          key={idx}
                          className={`dot ${selectedImage === img ? "active" : ""
                            }`}
                        ></span>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="product-info-details">
                  <div className="box-contoni">
                    <div className="flax-to-box">
                      <div className="product-profile">
                        <div className="main-profile">
                          <img
                            className="profile-img"
                            src={
                              product.userId?.avatar
                                ? product.userId.avatar
                                : `https://api.dicebear.com/7.x/initials/svg?seed=${product.userId?.name?.charAt(0) || "U"
                                }`
                            }
                            alt="Seller Avatar"
                          />
                          <div className="seller-info">
                            <h3>{product.userId?.name || "Seller"}</h3>
                          </div>
                        </div>
                      </div>
                      <button
                        onClick={() => handleSharea(product)}
                        className="share-button"
                        title="Share this product"
                      >
                        <HiMiniShare size={25} />
                      </button>
                    </div>
                    <div style={{ border: "1px solid #f5f2f2f5", borderRadius: "8px", marginBottom: "12px" }} />
                    <div className="title-share">
                      <div className="product-detatil">
                        <h2>{toProperCase(product.title)}</h2>
                        <div className="rating-badgews">
                          <MdStar />
                          <span>
                            {(Number(product.averageRating || 0)).toFixed(1)}{" "}
                            <span style={{ color: "#888" }}>
                              ({reviews?.length || 0} Reviews)
                            </span>
                          </span>
                        </div>
                      </div>
                      {/* <div
                        className="availability-btn"
                        onClick={() => setShowCalendar(true)}
                      >
                        <span style={{ fontSize: "15px" }}>Availability</span>
                        <span className="calendar-icon">
                          <img src={calendarIcon} alt="Calendar" />
                        </span>

                      </div> */}
                      <div
                        className="availability-btn"
                        onClick={() => setShowCalendar(true)}
                      >
                        <span style={{ color: "rgb(24, 21, 75)", fontSize: "15px" }}>Availability</span>
                        <img src={calendarIcon} alt="calendar" />
                      </div>

                    </div>

                    {showCalendar && (
                      <Calendars
                        isVendor={isMyProduct}
                        productId={product._id}
                        bookingDates={product?.rentedDates || []}
                        updateVendorBookingDate={async (dates, productId) => {
                          // console.log("API CALL", dates, productId);
                          return true; // success
                        }}
                        onClose={() => {
                          setShowCalendar(false);
                        }}
                        onDone={(data) => {
                          // setRentDates(data.rentDates);
                          setShowCalendar(false);
                          // console.log("DONE", data);
                        }}
                      />
                    )}
                    <div style={{ border: "1px solid #f5f2f2f5", borderRadius: "8px", marginTop: "12px", }} />
                    <div className="locations-wrapper">
                      <div
                        className="locations"
                        onClick={() => setShowPopup((prev) => !prev)}
                        style={{ cursor: "pointer" }}
                      >
                        <span role="img" aria-label="location">
                          <IoLocationOutline />
                        </span>
                        {fullAddress}
                      </div>
                      {showPopup && (
                        <div className="popup-menu">
                          <button className="popup-btn" onClick={handleCopy}>
                            <MdCopyAll /> Copy
                          </button>
                          <button className="popup-btn" onClick={handleShare}>
                            <IoShareSocialOutline /> Share
                          </button>
                        </div>
                      )}
                      {copied && <div className="copied-toast">Copied!</div>}
                    </div>
                  </div>


                  <div className="contron-box">
                    <div className="priceo">
                      <span style={{ color: "#18154b", fontSize: 20, fontWeight: 500 }}>
                        Rent
                      </span>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          flexWrap: "wrap",
                        }}
                      >
                        {/* FINAL PRICE */}
                        <span
                          style={{
                            color: "#EA0F43",
                            fontSize: 22,
                            fontWeight: 700,
                          }}
                        >
                          ₹
                          {calculateDiscountedPrice(
                            product.price,
                            product.discount
                          ).toLocaleString("en-IN")}
                        </span>

                        {/* RENT TYPE */}
                        {product?.rentType && (
                          <span
                            style={{
                              fontSize: 14,
                              fontWeight: 500,
                              color: "#444",
                            }}
                          >
                            / {product.rentType}
                          </span>
                        )}

                        {/* ORIGINAL PRICE */}
                        {Number(product.discount) > 0 && (
                          <span
                            style={{
                              fontSize: 15,
                              color: "#6b6969",
                              textDecoration: "line-through",
                            }}
                          >
                            ₹{Number(product.price).toLocaleString("en-IN")}
                          </span>
                        )}

                        {/* DISCOUNT */}
                        {Number(product.discount) > 0 && (
                          <span
                            style={{
                              fontSize: 15,
                              color: "#4CAF50",
                              fontWeight: 600,
                            }}
                          >
                            {product.discount}% OFF
                          </span>
                        )}
                      </div>
                    </div>





                    <div className="product-info">
                      <div className="info-two-column">
                        {/* Driver type */}
                        {hasValidValue(product?.driver_type) && (
                          <div className="info-row">
                            <strong className="font-strong">Driver type</strong>
                            <div>{driverTypeLabel(product.driver_type) || "-"}</div>
                          </div>
                        )}

                        {/* Product info (2 columns) */}
                        {[0, 1].map((col) => (
                          <div key={col}>
                            {productInfo
                              .filter((_, i) => i % 2 === col)
                              .map(({ label, value }, idx) => (
                                <div key={idx} className="info-row">
                                  <strong className="font-strong">{label}</strong>
                                  <div>{value?.trim() || "-"}</div>
                                </div>
                              ))}
                          </div>
                        ))}

                        {/* Amenities */}
                        <div className="info-row">
                          <strong className="font-strong">Add More Detail</strong>
                          <div>
                            {Array.isArray(product?.amenities)
                              ? product.amenities.length > 0
                                ? product.amenities.join(", ")
                                : "-"
                              : product?.amenities?.trim() || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="product-box">
                    <div className="review-section">
                      <h4>Description</h4>
                      <p>{toProperCase(product.description)}</p>
                    </div>
                  </div>



                  <div className="bottom-actions">
                    <button
                      className="call-btn"
                      onClick={() =>
                        handleAction("call", product?.userId?.phoneNumber)
                      }
                    >
                      <span>
                        <IoCallOutline /> {t("callWith")}
                      </span>
                    </button>
                    <button
                      className="chat-btns"
                      onClick={() =>
                        handleAction(
                          "chat",
                          product?.userId?.phoneNumber,
                          product?.title
                        )
                      }
                    >
                      <span>
                        <img
                          src={whatsapp}
                          className="whatsapp-icon"
                          alt="WhatsApp icon"
                        />
                        {t("chat")}
                      </span>
                    </button>
                  </div>
                  {!isMyProduct && (
                    <div className="review-section">
                      <h4>{t("reviews")}</h4>
                      <div className="stars">
                        {[1, 2, 3, 4, 5].map((i) => (
                          <MdStar
                            key={i}
                            color={i <= userRating ? "#FFD700" : "#ccc"}
                            onClick={() => setUserRating(i)}
                            size={24}
                            style={{ cursor: "pointer" }}
                          />
                        ))}
                      </div>
                      <textarea
                        className="review-text"
                        placeholder="Write your review here..."
                        value={reviewText}
                        onChange={(e) => setReviewText(e.target.value)}
                      />
                      <div className="review-add-btn">
                        <button
                          className="add-btns"
                          onClick={() => handleAction("addReview")}
                        >
                          {t("add")}
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="all-review">
                    {reviews ? (
                      reviews.map((review) => (
                        <div key={review._id} className="review-card">
                          <div className="review-body">
                            <div className="review-left">
                              <div className="dule">
                                <img
                                  className="review-avatar"
                                  src={
                                    review.userId?.avatar ||
                                    `https://api.dicebear.com/7.x/initials/svg?seed=${review.userId?.name
                                      ?.charAt(0)
                                      .toUpperCase() || "U"
                                    }`
                                  }
                                  alt="User Avatar"
                                />
                                <div className="review-header">
                                  <h4>{review.userId?.name || "User"}</h4>
                                </div>
                              </div>
                              {loggedInUser?._id === review.userId?._id && (
                                <div className="review-action-icons">

                                  <button
                                    className="icon-btn-n edit-btn-p"
                                    onClick={() => handleEdit(review._id)}
                                  >
                                    <MdEdit size={18} />
                                  </button>

                                  <button
                                    className="icon-btn-n delete-btn-s"
                                    onClick={() => handleDelete(review._id)}
                                  >
                                    <MdDeleteForever size={18} />
                                  </button>

                                </div>
                              )}
                            </div>
                            <div className="review-date">
                              <span>
                                {new Date(
                                  review.updatedAt
                                ).toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                })}
                              </span>
                            </div>
                          </div>
                          <h5 className="review-texti">
                            {review.text ||
                              review.reviewText ||
                              "No review text."}
                          </h5>

                          <div className="all-reviewe">
                            <div className="review-stars">
                              {[1, 2, 3, 4, 5].map((star) => (
                                <MdStar
                                  key={star}
                                  size={20}
                                  color={
                                    star <= review.rating ? "#FFD700" : "#ccc"
                                  }
                                />
                              ))}
                            </div>

                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="reviews-no">{t("what_say_clients")}</p>

                    )}
                  </div>
                </div>
              </div>
            </div>




            {/* mobile view */}
            <div
              className="breadcrumbu mobile-view"
              onClick={() => handleBack()}
            >
              <span className="arro">
                <img src={ArroIcon} alt="Back" />
              </span>

              <div className="product-profileee">
                <div className="main-profilea">
                  <img
                    className="profilea-img"
                    src={
                      product.userId?.avatar
                        ? product.userId.avatar
                        : `https://api.dicebear.com/7.x/initials/svg?seed=${product.userId?.name?.charAt(0) || "U"
                        }`
                    }
                    alt="Seller Avatar"
                  />
                  <div className="sellere-info">
                    <h3>{`${product.userId?.name || ""} ${product.userId?.lastName || "Seller"}`}</h3>
                  </div>
                </div>
                <IoShareSocialOutline
                  className="shara"
                  onClick={(e) => {
                    e.stopPropagation(); // ✅ IMPORTANT FIX

                    if (navigator.share) {
                      navigator.share({
                        title: "Check this out!",
                        text: "Here’s something cool I found.",
                        url: window.location.href,
                      });
                    } else {
                      alert("Sharing not supported on this device");
                    }
                  }}
                />

              </div>
            </div>
            <div className="mobile-only">
              <div className="pro-img">
                {/* MAIN IMAGE SCROLLER */}
                <div
                  className="main-img-scroll"
                  onScroll={(e) => {
                    const scrollLeft = e.currentTarget.scrollLeft;
                    const width = e.currentTarget.offsetWidth;
                    const activeIndex = Math.round(scrollLeft / width);
                    setSelectedImage(images[activeIndex]);
                  }}
                >
                  {images.map((img, index) => (
                    <div className="img-slide" key={index}>
                      <img
                        src={img}
                        alt={`product-${index}`}
                        onClick={() => {
                          setActiveIndex(index);
                          setIsViewerOpen(true); // 🔥 OPEN FULLSCREEN
                        }}
                      />
                    </div>
                  ))}
                </div>

                {/* DOTS */}
                <div className="img-dots">
                  {images.map((img, i) => (
                    <span
                      key={i}
                      className={`dot ${img === selectedImage ? "active" : ""}`}
                      onClick={() => {
                        document.querySelector(".main-img-scroll").scrollTo({
                          left: i * document.querySelector(".main-img-scroll").offsetWidth,
                          behavior: "smooth",
                        });
                        setSelectedImage(img);
                      }}
                    />
                  ))}
                </div>
              </div>

              {isViewerOpen && (
                <div className="image-viewer-overlay">

                  {/* CLOSE */}
                  <button
                    className="viewer-close"
                    onClick={() => setIsViewerOpen(false)}

                  >
                    <MdOutlineArrowBackIosNew />
                  </button>

                  {/* SCROLL IMAGES */}
                  <div
                    className="viewer-scroll"
                    onScroll={(e) => {
                      const width = e.currentTarget.offsetWidth;
                      const index = Math.round(e.currentTarget.scrollLeft / width);
                      setActiveIndex(index);
                      setZoomedIndex(null); // zoom reset on swipe
                    }}
                  >
                    {images.map((img, index) => (
                      <div className="viewer-slide" key={index}>
                        <img
                          src={img}
                          alt={`viewer-${index}`}
                          className={zoomedIndex === index ? "zoomed" : ""}
                          style={{
                            transformOrigin:
                              zoomedIndex === index ? `${origin.x} ${origin.y}` : "center",
                          }}
                          onClick={() =>
                            setZoomedIndex(zoomedIndex === index ? null : index)
                          }
                          onMouseMove={(e) => handleMove(e, index)}
                          onMouseLeave={() => setOrigin({ x: "50%", y: "50%" })}
                        />
                      </div>
                    ))}
                  </div>


                  {/* DOTS */}
                  <div className="viewer-dots">
                    {images.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === activeIndex ? "active" : ""}`}
                        onClick={() => {
                          document.querySelector(".viewer-scroll").scrollTo({
                            left:
                              i *
                              document.querySelector(".viewer-scroll").offsetWidth,
                            behavior: "smooth",
                          });
                          setActiveIndex(i);
                        }}
                      />
                    ))}
                  </div>
                </div>
              )}




              <div className="product-detatil-mobile">

                {/* TITLE + AVAILABILITY */}
                <div className="title-availability-row">
                  <h2 className="product-title">
                    {toProperCase(product.title)}
                  </h2>

                  <div
                    className="availability-btn"
                    onClick={() => setShowCalendar(true)}
                  >
                    <span style={{ color: "rgb(24, 21, 75)", fontSize: "15px" }}>Availability</span>
                    <img src={calendarIcon} alt="calendar" />
                  </div>
                </div>

                {showCalendar && (
                  <Calendars
                    isVendor={isMyProduct}
                    productId={product._id}
                    bookingDates={product?.rentedDates || []}
                    updateVendorBookingDate={async (dates, productId) => {
                      return true; // success
                    }}
                    onClose={() => {
                      setShowCalendar(false);
                    }}
                    onDone={(data) => {
                      setShowCalendar(false);
                    }}
                  />
                )}

                {/* Rating */}
                <div className="rating-badgews">
                  <MdStar />
                  <span>
                    {(Number(product.averageRating || 0)).toFixed(1)}{" "}
                    <span style={{ color: "#888" }}>
                      ({reviews?.length || 0} Reviews)
                    </span>
                  </span>
                </div>
                <div style={{ border: "1px solid #f5f2f2f5", borderRadius: "8px", marginBottom: 12 }} />
                <div className="location-combo">
                  <div className="locationsf">
                    <img
                      src={locationIcon}
                      alt="Location"
                      className="location-icon"
                    />
                    {fullAddress}
                  </div>

                  <div
                    style={{
                      position: "relative",
                      cursor: "pointer",
                      width: "31px",
                      height: "29px"
                    }}
                    onClick={copyAddress}
                  >
                    <IoShareSocialOutline className="sharas" />

                    {copied && (
                      <span
                        style={{
                          position: "absolute",
                          top: "-22px",
                          right: "0",
                          background: "#000",
                          color: "#fff",
                          fontSize: "11px",
                          padding: "2px 6px",
                          borderRadius: "4px",
                          whiteSpace: "nowrap"
                        }}
                      >
                        Copied!
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="loalo">
                <div
                  style={{
                    color: "#EA0F43",
                    fontWeight: 600,
                    fontSize: 18,
                    marginBottom: 8,
                    borderBottom: "1px solid #f5f2f2f5",
                    padding: 12,
                  }}
                >
                  <span style={{ color: "#18154b", fontSize: 20, fontWeight: 500 }}>Rent</span>
                  <br />
                  ₹
                  {calculateDiscountedPrice(
                    product.price,
                    product.discount
                  ).toLocaleString("en-IN")}
                  {product?.rentType && (
                    <span
                      style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#444",
                        marginRight: "6px",
                      }}
                    >
                      / {product.rentType}
                    </span>
                  )}


                  {Number(product.discount) > 0 && (
                    <span
                      style={{
                        fontSize: 15,
                        color: "#6b6969",
                        textDecoration: "line-through",
                        marginRight: "6px",
                      }}
                    >
                      ₹{Number(product.price).toLocaleString("en-IN")}
                    </span>
                  )}


                  {Number(product.discount) > 0 && (
                    <span
                      style={{
                        fontSize: 15,
                        color: "#4CAF50",
                        fontWeight: 600,
                      }}
                    >
                      {product.discount}% OFF
                    </span>
                  )}
                </div>


                {/* DETAILS GRID */}
                <div className="dule">
                  {/* 🔹 2-column product info */}
                  {Array.from({ length: 2 }).map((_, col) => (
                    <div key={col}>
                      {productInfo
                        .filter((_, i) => i % 2 === col)
                        .map((item, idx) => (
                          <div key={idx} className="info-row">
                            <strong className="font-strong">{item.label}</strong>
                            <div style={{ color: "#A3A3A3", fontWeight: "400", fontSize: "14px" }}>{item.value?.trim() || "-"}</div>
                          </div>
                        ))}
                    </div>
                  ))}

                  {/* 🔹 Add More Detail – ONLY ONCE */}
                  <div className="info-row">
                    <strong className="font-strong">Add More Detail</strong>
                    <div>
                      {Array.isArray(product?.amenities)
                        ? product.amenities.length > 0
                          ? product.amenities.join(", ")
                          : "-"
                        : product?.amenities?.trim() || "-"}
                    </div>
                  </div>

                  {/* 🔹 Driver type – ONLY ONCE */}
                  {hasValidValue(product?.driver_type) && (
                    <div className="info-row">
                      <strong className="font-strong">Driver type</strong>
                      <div>{driverTypeLabel(product.driver_type) || "-"}</div>
                    </div>
                  )}
                </div>



              </div>
              {/* DESCRIPTION */}
              <div className="product-detatil-mobile">
                <div className="review-section">
                  <h4>Description</h4>
                  <p >
                    {toProperCase(product.description)}
                  </p>
                </div>
              </div>

              <div className="mobile-bottom-buttons">
                <button
                  className="mobile-btn call"
                  onClick={() =>
                    handleAction("call", product?.userId?.phoneNumber)
                  }
                >
                  <IoCallOutline /> Call
                </button>

                <button
                  className="mobile-btn chat"
                  onClick={() =>
                    handleAction(
                      "chat",
                      product?.userId?.phoneNumber,
                      product?.title
                    )
                  }
                >
                  <img
                    src={whatsapp}
                    className="whatsapp-iconq"
                    alt="WhatsApp icon"
                  />
                  Chat
                </button>
              </div>
              {reviews?.length > 0 && (
                <div className="reviews-box">
                  <h4 className="reviews-title">Reviews</h4>

                  {!isMyProduct && (
                    <>
                      {/* Rating Stars */}
                      <div className="rating-input">
                        {[1, 2, 3, 4, 5].map((i) => (
                          <MdStar
                            key={i}
                            size={22}
                            className={i <= userRating ? "star active" : "star"}
                            onClick={() => setUserRating(i)}
                          />
                        ))}
                      </div>

                      {/* Review Input */}
                      <div className="review-input-row">
                        <textarea
                          value={reviewText}
                          onChange={(e) => setReviewText(e.target.value)}
                        />
                      </div>

                      <div style={{ textAlign: "right", marginTop: "11px" }}>
                        <button
                          className="lokiadd"
                          onClick={() => handleAction("addReview")}
                        >
                          Add
                        </button>
                      </div>
                    </>
                  )}

                  {/* Review List */}
                  <div className="reviews-list">
                    {reviews.map((review) => (
                      <div key={review._id} className="review-item">
                        <div className="review-header">
                          <div className="review-user">
                            <img
                              className="review-avatar"
                              src={
                                review.userId?.avatar ||
                                `https://api.dicebear.com/7.x/initials/svg?seed=${review.userId?.name?.charAt(0).toUpperCase() || "U"
                                }`
                              }
                              alt="User Avatar"
                            />
                            <div>
                              <p className="name">{review.userId?.name || "User"}</p>
                              <div className="starsd">
                                {[1, 2, 3, 4, 5].map((s) => (
                                  <MdStar
                                    key={s}
                                    size={14}
                                    className={s <= review.rating ? "star active" : "star"}
                                  />
                                ))}
                              </div>
                            </div>
                          </div>

                          {loggedInUser?._id === review.userId?._id && (
                            <div className="review-action-iconsd">
                              <button
                                className="icon-btn-n edit-btn-p"
                                onClick={() => handleEdit(review._id)}
                              >
                                <MdEdit size={18} />
                              </button>

                              <button
                                className="icon-btn-n delete-btn-s"
                                onClick={() => handleDelete(review._id)}
                              >
                                <MdDeleteForever size={18} />
                              </button>
                            </div>
                          )}

                          <span className="date">
                            {new Date(review.createdAt).toLocaleDateString()}
                          </span>
                        </div>

                        <p className="review-texth">
                          {review.text || review.reviewText}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              )}


            </div>
          </div>
          {/* LOGIN POPUP */}
          {showLoginPopup && (
            <div className="login-popup-overlaya">
              <div className="login-popupd">
                <h4>Please Log In</h4>
                <p>You need to be logged in to use this feature.</p>
                <div className="login-popup-buttonsa">
                  <button
                    className="cancel-btnn"
                    onClick={() => setShowLoginPopup(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="login-btnn"
                    onClick={() => navigate("/login")}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          )}
          <Footer />
        </NoCopyWrapper >
      </NoZoomWrapper >
    </>
  );
};

export default ProdouctCloth;
